import { FC, useCallback } from "react";
import { observer } from "mobx-react-lite";

import { EmptyContainer } from "@/components/styling/empty/empty-container";
import { EmptyText } from "@/components/styling/empty/empty-text";
import { MDSButton } from "@/mds";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";

type Props = Record<string, never>;

export const AudioRecordingsListPageListEmpty: FC<Props> = observer(() => {
  const page = useTabPageStore("audioRecordingsListPage");

  const handleCreateRecording = useCallback(() => {
    page.handleCreateRecording();
  }, [page]);

  return (
    <EmptyContainer>
      <EmptyText>No audio recordings yet.</EmptyText>
      <MDSButton onClick={handleCreateRecording}>New recording</MDSButton>
    </EmptyContainer>
  );
});
